import { FC } from 'react';
import { CompanyOption } from '@/types/assistant';

interface Props {
  /** id da empresa ativa da conversa (null = ainda não definida). */
  value: string | null;
  companies: CompanyOption[];
  onSelect: (companyId: string) => void;
  disabled?: boolean;
}

/**
 * Indicador "Gerando para: {empresa} ▾" no header do chat (G14, F2-D2).
 *
 * Mostra a marca ativa da conversa e deixa trocar rápido (chama o endpoint leve
 * `set_company`, sem custar um turno de LLM). Sem empresa definida, sinaliza que é
 * preciso escolher — o bot também pergunta antes de gerar o 1º arquivo.
 */
const CompanyIndicator: FC<Props> = ({ value, companies, onSelect, disabled }) => {
  if (!companies || companies.length === 0) return null;

  return (
    <div
      data-testid="company-indicator"
      className="flex items-center gap-2 px-4 py-1.5 border-b border-surface-border bg-surface-secondary text-xs"
    >
      <span className="material-symbols-outlined text-sm leading-none text-content-tertiary">
        corporate_fare
      </span>
      <span className="text-content-tertiary">Gerando para:</span>
      <select
        data-testid="company-select"
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => {
          if (e.target.value) onSelect(e.target.value);
        }}
        aria-label="Empresa para geração de arquivos"
        className={`bg-surface-primary border rounded-lg px-2 py-1 text-content-primary focus:border-accent focus:outline-none disabled:opacity-50 max-w-[200px] ${
          value ? 'border-surface-border font-medium' : 'border-amber-500/60 text-amber-500'
        }`}
      >
        {!value && (
          <option value="" disabled>
            Escolha a empresa…
          </option>
        )}
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanyIndicator;
